import React, { CSSProperties } from 'react';
import { BZMIconClasses, Icon } from '@blazemeter/blaze-ct-ui-components';

type BzmIconProps = {
  /**
   * Icon className.
   */
  variant: BZMIconClasses | string;

  /**
   * Size in pixels.
   */
  size?: number;

  /**
   * Color (HEX / RGBa)
   */
  color?: string;
  title?: string;
  className?: string;
  onClick?: any;
  style?: CSSProperties;
};

const BzmIcon = (props: BzmIconProps) => {
  const buildStyle = {
    fontSize: props.size ? props.size + 'px' : undefined,
    color: props.color ? props.color : undefined,
  };
  const bzmIconStyle = props.style ? { ...props.style, ...buildStyle } : buildStyle;
  return (
    <span style={bzmIconStyle} onClick={props.onClick} title={props.title ? props.title : undefined} aria-hidden={true}>
      <Icon extraClass={props.className} iconClass={props.variant} />
    </span>
  );
};

export default BzmIcon;
